import Const from 'constants';

function sortByProperty(name, direction = 'asc') {
    if (direction === 'asc') {
        return function (a, b) {
            if (a[name] < b[name]) {
                return -1;
            } else if (a[name] > b[name]) {
                return 1;
            }

            return 0;
        };
    } else if (direction === 'desc') {
        return function (a, b) {
            if (a[name] > b[name]) {
                return -1;
            } else if (a[name] < b[name]) {
                return 1;
            }

            return 0;
        };
    }

    throw new Error(`Wrong sort direction: "${direction}".`);
}

function sortByProperties(propNames, direction = 'asc') {
    if (direction === 'asc') {
        return function (a, b) {
            for (const propName of propNames) {
                if (a[propName] < b[propName]) {
                    return -1;
                } else if (a[propName] > b[propName]) {
                    return 1;
                }
            }

            return 0;
        };
    } else if (direction === 'desc') {
        return function (a, b) {
            for (const propName of propNames) {
                if (a[propName] > b[propName]) {
                    return -1;
                } else if (a[propName] < b[propName]) {
                    return 1;
                }
            }

            return 0;
        };
    }

    throw new Error(`Wrong sort direction: "${direction}".`);
}

function getPlayersSortColumns(params) {
    const {gameType, sport, site = null} = params;
    const sortColumns = Const.PLAYERS_SORT_COLS_LIST[sport][gameType];
    if (site && sortColumns.hasOwnProperty(site)) {
        return {...sortColumns[site]};
    }
    return {...sortColumns};
}

export {sortByProperty, getPlayersSortColumns, sortByProperties};
